import React, { useRef, useEffect, useState, useImperativeHandle, forwardRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import '../../../../../../../../styles.css';

import {
  getCaretIndex,
  isFirefox,
  updateCaret,
  insertNodeAtCaret,
  getSelection,
  updateCaretToNextLine
} from '../../../../../../utils/contentEditable';
import useApiPost from '../../../../../../../../hooks/api';
import { MdAttachFile } from "react-icons/md";
import { FaRegFaceSmile } from "react-icons/fa6";
import { PiMapPinArea } from "react-icons/pi";
import WebSocketManager from '../../../../../../../../manager/WebSocketManager';
import { delay, getUserId, local, shortenFileName } from '../../../../../../../../utils/helper';
import UploadedFile from './uploadedFile';
import { resetMessages, setLoadingMessages, toggleSendDisabled } from '../../../../../../store/actions';
import { HiOutlineMicrophone } from "react-icons/hi";
import useAudioRecorder from '../../../../../../../../hooks/useAudioRecorder';
import ConsoleUtils from '../../../../../../../../utils/console';

const webSocketManager = new WebSocketManager();
const send = './images/send.png';
const emoji = './images/assets/icon-smiley.svg';
const brRegex = /<br>/g;
let socketReconnect = false;

const Sender = forwardRef(
  (
    {
      sendMessage,
      // placeholder,
      disabledInput,
      autofocus,
      onTextInputChange,
      buttonAlt,
      config,
      onPressEmoji,
      onChangeSize
    },
    ref
  ) => {
    const dispatch = useDispatch();
    const { disabledSend, showChat, widgetConfig, showSenderComponent, isSessionAvailable } = useSelector((state) => ({
      showChat: state.behavior.showChat,
      disabledSend: state.behavior.disabledSend,
      showSenderComponent: state.messages.showSenderComponent,
      widgetConfig: state.messages.widgetConfig,
      isSessionAvailable: state.messages.isSessionAvailable
    }));
    const myAudio = useRef();
    const inputRef = useRef(null);
    const refContainer = useRef(null);
    const [enter, setEnter] = useState(false);
    const [firefox, setFirefox] = useState(false);
    const [height, setHeight] = useState(0);
    const [fileInput, setFileInput] = useState(false);
    const { data, error, loading, postRequest, setData } = useApiPost(`${config.accessKey}`);
    const [formData, setFormData] = useState()
    const [showReconnet, setShowReconnect] = useState(false)
    const [reconnectLoad, setReconnectLoad] = useState(false)
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileUploading, setFileUploading] = useState(false)
    const [startCalling, setStartCalling] = useState(false);
    const {
      init,
      endSession,
      resMessage,
      errorMessage,
      isStartSession,
      setIsStartSession,
      hideMicrophone,
      startPlayer
    } = useAudioRecorder();

    useEffect(() => {
      if (showChat && autofocus) {
        inputRef?.current?.focus();
      }
    }, [showChat, autofocus]);

    useEffect(() => {
      setFirefox(isFirefox());
    }, []);

    useImperativeHandle(ref, () => ({
      onSelectEmoji: handlerOnSelectEmoji
    }));

    const handlerOnChange = (event) => {
      let text = event.target.innerHTML;

      // Replace <br> tags with empty space and trim whitespace
      text = text.replace(/<br\s*\/?>/gi, "").trim();

      if (inputRef.current && text === '') {
        inputRef.current.innerHTML = "";
        inputRef.current.focus(); // Ensures placeholder shows up again
      }

      setFormData(text);

      if (onTextInputChange) {
        onTextInputChange(event);
      }
    };
    const uploadFile = (file) => {
      try {
        const req = { file: file };
        postRequest(`${config.api}/media`, req);
      } catch (error) {
        alert(error);
      }
    };
    const cleanText = (text) => text.replace(/&nbsp;/g, ' ').trim();

    const handlerSendMessage = () => {
      const el = inputRef.current;
      if (!el) {
        ConsoleUtils.error('Invalid text');
        return;
      }

      setFileInput(false);

      const content = el.innerHTML;
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, 'text/html');
      const cleanTexts = doc.body.textContent || '';

      let textContent = '';

      const extractText = (node) => {
        node.childNodes.forEach((child) => {
          if (child.nodeType === Node.TEXT_NODE) {
            textContent += child.textContent;
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            const tag = child.tagName;

            if (tag === 'BR') {
              textContent += '\n';
            } else {
              extractText(child);
              if (tag === 'DIV' || tag === 'P') {
                textContent += '\n';
              }
            }
          }
        });
      };

      extractText(doc.body);
      textContent = textContent.trim();

      if (!cleanTexts.trim() && !textContent && uploadedFiles.length === 0) {
        return;
      }

      ConsoleUtils.log({ doc, textContent, content });

      if (uploadedFiles.length > 0) {
        if (data) {
          const parts = content.split('</div>');
          const lastChunk = parts[parts.length - 1]?.trim() || '';
          const textAfterImg = cleanText(lastChunk);

          const sendData = {
            data,
            endText: textAfterImg !== '<br>' ? textContent : '',
          };

          sendMessage(sendData);
          setUploadedFiles([]);
        } else {
          alert('File not Uploaded');
        }
      } else {
        sendMessage(textContent);
      }
      dispatch(setLoadingMessages(false));
      el.innerHTML = '';
      setFormData();
    };

    const handlerOnSelectEmoji = (emoji) => {

      const el = inputRef.current;
      if (el) {
        const { start, end } = getSelection(el);
        let content = el.innerHTML.replace(/&nbsp;/g, ' ');
        const firstPart = content.substring(0, start);
        const secondPart = content.substring(end);
        el.innerHTML = `${firstPart}${emoji.emoji}${secondPart}`;
        setFormData(el.innerHTML);
        updateCaret(el, start, emoji.emoji.length);
      }
    };

    const handlerOnKeyPress = (event) => {
      const el = inputRef.current;
      if (!disabledSend) {
        if (event.charCode === 13 && !fileUploading) {
          if (!event.shiftKey) {
            event.preventDefault();
            handlerSendMessage();
          } else {
            event.preventDefault();
            insertNodeAtCaret(el);
            setEnter(true);
          }
        }
      }
    };

    const checkSize = () => {
      const senderEl = refContainer.current;
      if (senderEl && height !== senderEl.clientHeight) {
        const { clientHeight } = senderEl;
        setHeight(clientHeight);
        onChangeSize(clientHeight ? clientHeight - 1 : 0);
      }
    };

    const handlerOnKeyUp = (event) => {
      const el = inputRef.current;
      if (!el) return true;
      if (firefox && event.key === 'Backspace') {
        if (el.innerHTML.length === 1 && enter) {
          el.innerHTML = '';
          setEnter(false);
        } else if (brRegex.test(el.innerHTML)) {
          el.innerHTML = el.innerHTML.replace(brRegex, '');
        }
      }
      checkSize();
    };

    const handlerOnKeyDown = (event) => {
      const el = inputRef.current;
      if (disabledSend) return true;

      if (event.key === 'Enter' && event.shiftKey) {
        event.preventDefault(); // Prevent default Shift+Enter behavior

        // Insert a new line
        document.execCommand('insertLineBreak');

        // Keep cursor in view
        requestAnimationFrame(() => keepCursorVisible(inputRef.current));
      }
      if (event.key === 'Backspace' && el) {
        const caretPosition = getCaretIndex(inputRef.current);
        const character = el.innerHTML.charAt(caretPosition - 1);
        if (character === '\n') {
          event.preventDefault();
          event.stopPropagation();
          el.innerHTML = `${el.innerHTML.substring(0, caretPosition - 1)}${el.innerHTML.substring(caretPosition)}`;
          updateCaret(el, caretPosition, -1);
        }
      }
    };

    const keepCursorVisible = (element) => {
      if (!element) return;

      // Get cursor position
      const range = document.createRange();
      const selection = window.getSelection();

      range.selectNodeContents(element);
      range.collapse(false); // Move cursor to end
      selection.removeAllRanges();
      selection.addRange(range);

      // Scroll to cursor (without jumping to bottom)
      element.scrollTop = element.scrollHeight;
    };

    const handlerPressEmoji = () => {
      onPressEmoji();
      checkSize();
    };

    const handleFileChange = (event) => {
      setFileUploading(true)
      setUploadedFiles([])
      setData(null)
      const file = event.target.files[0];
      if (file) {
        const maxSize = {
          image: 10 * 1024 * 1024, // 10MB
          video: 25 * 1024 * 1024, // 25MB
          document: 10 * 1024 * 1024, // 10MB
          audio: 10 * 1024 * 1024 // 10MB
        };

        const allowedTypes = {
          image: ['image/jpeg', 'image/png', 'image/gif'],
          video: ['video/mp4', 'video/webm'],
          document: [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ],
          audio: ['audio/mp3', 'audio/wav', 'audio/mpeg', 'audio/ogg']
        };

        let fileType;
        if (allowedTypes.image.includes(file.type)) {
          fileType = 'image';
        } else if (allowedTypes.video.includes(file.type)) {
          fileType = 'video';
        } else if (allowedTypes.document.includes(file.type)) {
          fileType = 'document';
        } else if (allowedTypes.audio.includes(file.type)) {
          fileType = 'audio';
        } else {
          alert('Invalid file type. Please upload a valid image, video, document, or audio file.');
          return;
        }

        // Check file size
        if (file.size > maxSize[fileType]) {
          alert(
            `File size exceeds ${maxSize[fileType] / (1024 * 1024)}MB. Please upload a smaller ${fileType}.`
          );
          return;
        }

        const blobURL = URL.createObjectURL(file);
        const newFile = {
          id: Date.now(), // Unique identifier for the file
          name: file.name,
          type: fileType,
          previewURL: blobURL,
          file: file
        };
        uploadFile(file);

        setUploadedFiles((prevFiles) => [...prevFiles, newFile]);

      } else {
        setFileUploading(false);
        alert('file not supported');
      }
    };

    useEffect(() => {
      if (data?.output) {
        setFileUploading(false)
      }
    }, [data])

    const removeFile = (fileId) => {
      setUploadedFiles((prevFiles) => prevFiles.filter((file) => file.id !== fileId));
    };

    const handleFileSelectButtonClick = () => {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept =
        'image/jpeg, image/png, image/gif, video/mp4, video/webm, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, audio/mp3, audio/wav';
      fileInput.style.display = 'none'; // Hide the input element
      document.body.appendChild(fileInput);

      // Trigger the file input click
      fileInput.click();

      // Handle the file selection
      fileInput.addEventListener('change', handleFileChange);

      // Clean up after file selection is done
      fileInput.addEventListener('change', () => {
        document.body.removeChild(fileInput);
      });
    };
    const handlerPressFile = () => {
      handleFileSelectButtonClick();
    };

    const handleOnPaste = (event) => {
      // Prevent default paste behavior
      event.preventDefault();

      // Get plain text from clipboard
      const text = (event.clipboardData || window.clipboardData).getData('text');

      // Use Document.execCommand to insert text
      document.execCommand('insertText', false, text);

      // Update your state or perform additional actions
      setFormData(text);

      requestAnimationFrame(() => keepCursorVisible(inputRef.current));
    };


    const connectWebSocket = useCallback(
      (config) => {
        let userId = getUserId(config.widgetId);
        webSocketManager.init({
          url: config?.url,
          accessKey: config?.accessKey,
          widgetId: config?.widgetId,
          customerId: userId
        });
      },
      [config]
    );

    const handleReconnect = async () => {
      if (navigator?.onLine) {
        if (!isSessionAvailable) {
          const event = new CustomEvent("ratingSubmit", {
            detail: "Button was clicked!",
          });
          window.dispatchEvent(event);
          return;
        }
        setReconnectLoad(true)
        socketReconnect = true;

        const event = new CustomEvent("reconnectSocket");
        window.dispatchEvent(event);
      } else {
        alert("Please check your internet connection and try again")
      }
    }

    const reconnetSocketListener = async () => {
      endSession()
      setFormData()
      setUploadedFiles([])
      setReconnectLoad(false)
      socketReconnect = false;
      setShowReconnect(true)
    }

    const reconnetSocketOpen = () => {
      if (socketReconnect) {
        webSocketManager.send({
          id: '5397b5bf-e413-4dbc-bf9d-47bb7b5fbf53',
          payloadType: 'event',
          type: 'newPage',
          content: {
            pageNo: 1,
            pageSize: 20,
          },
        });
      }
      setReconnectLoad(false)
      socketReconnect = false;
      setShowReconnect(false)
    }

    useEffect(() => {
      webSocketManager.addListener('error', reconnetSocketListener);
      webSocketManager.addListener('open', reconnetSocketOpen);
      return () => {
        webSocketManager.removeListener('error', reconnetSocketListener);
        webSocketManager.removeListener('open', reconnetSocketOpen);
      };
    }, []);

    window.addEventListener("offline", function () {
      reconnetSocketListener()
    })

    useEffect(() => {
      if (!isStartSession && resMessage && widgetConfig?.widgetConfig?.lookAndFeel?.audioMode === 'audioToDictation') {
        ConsoleUtils.log('Res Message:', resMessage);
        setFormData(resMessage)
        if (inputRef?.current) {
          inputRef?.current?.focus();

          const selection = window.getSelection();
          if (!selection || selection.rangeCount === 0) {
            // Fallback: insert at end if no selection
            inputRef.current.innerText += ' ' + resMessage;
            return;
          }
          const range = selection.getRangeAt(0);
          const textNode = document.createTextNode(resMessage);
          range.deleteContents(); // Remove any selected text
          range.insertNode(textNode);

          // Move the cursor after the inserted node
          range.setStartAfter(textNode);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    }, [isStartSession])

    useEffect(() => {
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const newHeight = entry.contentRect.height;
          const ele = document.getElementsByClassName('scroll-to-bottom-btn')
          if (ele[0]) {
            ele[0].style.bottom = newHeight + 45 + 'px';
          }
        }
      });

      if (inputRef?.current) {
        observer.observe(inputRef?.current);
      }
    }, [inputRef?.current])

    function getUserMedia(options, successCallback, failureCallback) {
      var api = navigator.getUserMedia || navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if (api) {
        return api.bind(navigator)(options, successCallback, failureCallback);
      }
      alert('User Media API not supported.');
    }

    function handleMicrophone() {
      init()
      // startPlayer()
    }

    return (
      <>
        {!showReconnet ?
          <>
            {!showSenderComponent && <div className='rcw-sender-container'>
              {
                isStartSession &&
                <>
                  {!errorMessage ?
                    <div className='rcw-voice-sender'>
                      <div className='rcw-voice-message'>{resMessage ? resMessage : 'Loading...'}</div>
                      <button className="rcw-end-call-btn" type="button" onClick={endSession}>
                        <img src="./images/end-call.svg" className="rcw-end-call-icon" alt={buttonAlt} />
                      </button>
                    </div> :
                    <div className='rcw-voice-sender-error'>
                      <div className='rcw-voice-message-error'>{errorMessage}</div>
                      <button className="rcw-end-call-btn-error" type="button" onClick={() => setIsStartSession(false)}>
                        Back
                      </button>
                    </div>
                  }
                </>
              }
              <div className="rcw-sender">
                <audio ref={myAudio} autoPlay playsInline />
                {uploadedFiles.length > 0 && (
                  <UploadedFile uploadedFiles={uploadedFiles} removeFile={removeFile} fileUploading={fileUploading} />
                )}
                <div
                  className={cn('rcw-new-message', {
                    'rcw-message-disable': disabledInput
                  })}>
                  <div
                    spellCheck="true"
                    className="rcw-input"
                    role="textbox"
                    contentEditable={!disabledInput}
                    ref={inputRef}
                    placeholder="Type Your Message..."
                    onInput={handlerOnChange}
                    onKeyPress={(e) => {
                      if (!fileUploading) handlerOnKeyPress(e)
                    }
                    }
                    onKeyUp={handlerOnKeyUp}
                    onKeyDown={handlerOnKeyDown}
                    onPaste={handleOnPaste}
                  />
                </div>
                {/* <button className="rcw-picker-btn" type="button">
                    <PiMapPinArea color='#8F9195' size={22} />
                  </button> */}
                {!hideMicrophone && widgetConfig?.widgetConfig?.lookAndFeel?.audioMode && widgetConfig?.widgetConfig?.lookAndFeel?.audioMode !== "none" && <button className="rcw-picker-btn" type="button" onClick={handleMicrophone}>
                  <HiOutlineMicrophone color='#8F9195' size={22} />
                </button>}
                <button className="rcw-picker-btn" type="button" onClick={handlerPressEmoji}>
                  <FaRegFaceSmile color='#8F9195' size={22} />
                </button>
                <button className="rcw-picker-btn" type="button" onClick={handlerPressFile}>
                  <MdAttachFile className='attach-file' color='#8F9195' size={22} />
                </button>
                {(formData || uploadedFiles.length > 0) && <button type="button" className="rcw-send" style={{ cursor: fileUploading || disabledSend ? 'not-allowed' : '', opacity: fileUploading || disabledSend ? 0.6 : '' }} onClick={handlerSendMessage} disabled={fileUploading || disabledSend}>
                  <img src="./images/send.png" className="rcw-send-icon" alt={buttonAlt} />
                </button>}
              </div>
              {/* )} */}
            </div>}
          </>
          :
          <div className='rcw-reconnect-socket'>
            <div className='rcw-reconnect-message'>Can’t load new messages</div>
            <button className='rcw-reconnect-button' onClick={handleReconnect} disabled={reconnectLoad}>{!reconnectLoad ? "Reconnect" : "Reconnecting..."}</button>
          </div>
        }
      </>
    );
  }
);

export default Sender;
